var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "q-field",
        [
          !_vm.hide
            ? _c(
                "q-input",
                {
                  attrs: {
                    clearable: "",
                    "float-label": "Course",
                    placeholder: _vm.placeholder
                  },
                  on: { clear: _vm.select },
                  model: {
                    value: _vm.filter,
                    callback: function($$v) {
                      _vm.filter = $$v
                    },
                    expression: "filter"
                  }
                },
                [
                  _c("q-autocomplete", {
                    ref: "CourseAutoComplete",
                    attrs: {
                      debounce: 500,
                      "max-results": _vm.maxResults,
                      clearable: ""
                    },
                    on: { search: _vm.onSearch, selected: _vm.select }
                  })
                ],
                1
              )
            : _vm._e()
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }